<template>
    <v-app id="inspire">
        <v-card class="mx-auto" max-width="100%">
            <v-container>
                <v-row dense>
                    <v-col cols="12">
                        <v-card color="#385F73" dark>
                            <v-card-title class="headline">
                                Misión:
                            </v-card-title>

                            <v-card-text>
                                <p>
                                    * Desarrollar, implantar, mantener, actualizar, revisar y perfeccionar un sistema de
                                    gestión integrado que permita cumplir con la política y objetivos de la calidad,
                                    medio ambiente y seguridad y salud ocupacional para alcanzar la visión de la
                                    empresa.
                                </p>
                                <p>
                                    * Determinar, evaluar, analizar, revisar, consensuar y aprobar propuestas y acciones
                                    conducentes a la mejora continua.
                                </p>
                                <p>
                                    * Evaluar y calificar candidatos a auditores.
                                </p>
                                <p>
                                    * Auditar indirectamente procesos que por su naturaleza no pueden ser realizados por
                                    la auditoría interna.
                                </p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-app>
</template>

<script>
// import router from "../src/router/index";
// import axios from "../src/axios-auth.js";
import moment from "moment";

export default {
    data: () => ({
        usuario: null,
        now: moment(),
        diferencia: "",
    }),
    watch: {},
    created() {
        this.usuario = this.$store.state.usuario.toString().trim();
    },
    mounted() {
        if (this.$store.state.usuario == "" || this.$store.state.usuario == null) {
            this.$store.dispatch("logout");
        } else {
            this.$store.state.sector = "Comite";
            //  this.cargaraccidentes();
        }
    },
    methods: {},
};
</script>